/* global Sys, Services */
Sys.ns("Services");

/**
 * The Game Round Service.
 *
 * @class Services.GameRound
 * @extends Services.Base
 */
Services.GameRound = {
    constructor: function(config) {
        var parsedResponse;

        Services.GameRound.superclass.constructor.apply(this, arguments);

        parsedResponse = config.parsedResponse;
        this._roundActive = config.initResponse.restore === true;
        this._hasQuickStopped = false;
        this._isRespin = false;
        this._isGameDisabled = false;

        if (parsedResponse.g4mode) {
            this._isQuickStopAvailable = false;
        }
        else if (!(typeof parsedResponse.config === "undefined") && !(typeof parsedResponse.config.gameParameters === "undefined") && !(typeof parsedResponse.config.gameParameters.quickStopAvailable === "undefined")) {
            this._isQuickStopAvailable = parsedResponse.config.gameParameters.quickStopAvailable;
        }
        else {
            this._isQuickStopAvailable = true;
        }
    },

    _setupEvents: function() {
        this.observable.on({
            "notify:stateHandler.enteringIdleState": this._onGameRoundEnded.bind(
                this
            ),
            "notify:stateHandler.leavingIdleState": this._onGameRoundStarted.bind(
                this
            ),
            "notify:responseParser.responseParsed": this._onResponseParsed.bind(this),
            "request:stopGame.disable": this._onGameDisabled.bind(this)
        });
    },

    /**
     * Starts a new game round (if one is not already active) unless game is stopped.
     *
     * @returns {void}
     */
    start: function() {
        if (!this.isRoundActive() && !this._isGameDisabled) {
            this._hasQuickStopped = false;

            this._startNewRound();
            this.publish("startNewRound");
        }
    },

    /**
     * Quick stops the game round (if one is active and quick stop is available).
     *
     * @returns {void}
     */
    quickStop: function() {
        if (
            this.isRoundActive() &&
            this.isQuickStopAvailable() &&
            !this._hasQuickStopped
        ) {
            this._quickStop();

            this._hasQuickStopped = true;

            this.publish("quickStopped");
        }
    },

    /**
     * Checks if a game round is active.
     *
     * @returns {boolean} Whether or not a game round is active.
     */
    isRoundActive: function() {
        return this._roundActive;
    },

    /**
     * Checks if quick stop is active.
     *
     * @returns {boolean} Whether or not quick stop is active.
     */
    isQuickStopAvailable: function() {
        return this._isQuickStopAvailable;
    },

    /**
     * Checks if round is in respin mode.
     *
     * @returns {boolean} Whether or not in respin mode.
     */
    isRespin: function() {
        return this._isRespin;
    },

    /**
     * Handles a new round start request.
     *
     * @private
     * @returns {void}
     */
    _startNewRound: function() {
        this.observable.fireEvent("request:spin.startNewRound");
    },

    /**
     * Handles a quick stop request.
     *
     * @private
     * @returns {void}
     */
    _quickStop: function() {
        this.observable.fireEvent("request:spin.quickStop");
    },

    /**
     * Handles when a new game round has started.
     *
     * @private
     * @returns {void}
     */
    _onGameRoundStarted: function() {
        this._roundActive = true;

        this.publish("started");
    },

    /**
     * Handles when a game round has ended.
     *
     * @private
     * @returns {void}
     */
    _onGameRoundEnded: function() {
        if (!this._roundActive) {
            return;
        }

        this._roundActive = false;

        this.publish("ended");

        // If the game has been disabled by user request, disable the interface
        if (this._isGameDisabled) {
            this.publish("stopped");
        }
    },

    /**
     * Handles when a game has been disabled.
     *
     * @private
     * @returns {void}
     */
    _onGameDisabled: function() {
        this._isGameDisabled = true;
    },

    /**
     * Collects the information from the server response.
     *
     * @private
     * @param {Object} response The server response.
     * @returns {void}
     */
    _onResponseParsed: function(response) {
        this._isRespin = response.clientaction === "respin";
    }
};

Services.GameRound = Sys.extend(
    Services.Base,
    Services.GameRound,
    "Services.GameRound"
);
